import Header from './Header';
export default Header;
//# sourceMappingURL=index.js.map